module.exports = __webpack_public_path__ + "static/Dan-82a3d58ff996f603dfc588223a906bff.svg";